import { Radio } from "../../radio/radio.index";
import Button from "../../button/button.index";
import { ButtonType } from "../../button/button.interface";
import tick from "../../../../assets/images/icons/Tick.svg";
import { useEffect, useRef, useState } from "react";
import { ActionEnum, OverwriteProps } from "./overwrite.interface";
import { isFolder } from "../../../../scripts/helpers";
import Dialog from "../../dialog/dialog.index";
import { DialogSize } from "../../dialog/dialog.interface";

export default function Overwrite(props: OverwriteProps): JSX.Element {
    const [action, setAction] = useState<ActionEnum>(ActionEnum.KEEP);
    const [doForAll, setDoForAll] = useState<boolean>(false);
    const [status, setStatus] = useState(false);
    const buttonRef = useRef(null);

    useEffect(() => {
        setStatus(props.status);
    }, [props.status]);

    const handleCloseModal = () => {
        props.onClose();
    };

    const handleSubmit = () => {
        props.onSubmit(action, doForAll, props.files[0].id);
        if (doForAll || props.files.length - 1 === 0) {
            handleCloseModal();
        }
    };

    return (
        <Dialog status={status} onClose={handleCloseModal} title="آپلود مجدد فایل" closeButton={false} size={DialogSize.MD}>
            {props.files.length > 0 && (
                <div className="p-4">
                    <p className="text-[13px] text-secondary-500 leading-8">
                        فایل “{props.files[0].name}” از قبل در این مکان وجود دارد. آیا می‌خواهید فایل موجود را با نسخهٔ جدید جایگزین کنید یا هر دو
                        فایل را نگه دارید؟ جایگزین‌کردن فایل تنظیمات اشتراک‌گذاری را تغییر نمی‌دهد.
                    </p>
                    <div className="my-8">
                        <Radio
                            value={isFolder(props.currentData?.find((item) => item.name === props.files[0].name)!) ? ActionEnum.KEEP : action}
                            onChange={(value) => setAction(value)}
                            // options={[{ title: 'جایگزین کردن', payload: ActionEnum.REPLACE, disabled: isFolder(props.currentData?.find((item) => item.name === props.files[0].name)!) }, { title: 'نگه داشتن هر دو', payload: ActionEnum.KEEP }]}
                            options={[
                                { title: "جایگزین‌کردن", payload: ActionEnum.REPLACE, disabled: true },
                                { title: "نگه‌داشتن هر دو", payload: ActionEnum.KEEP }
                            ]}
                        />
                    </div>
                    <div className={`flex items-center gap-4 justify-end ${props.files.length > 1 && "mb-8"}`}>
                        <Button
                            type={ButtonType.TEXT}
                            text="لغو"
                            className="w-[150px] text-red-500 hover:text-red-700"
                            onClick={handleCloseModal}
                            autoFocus={false}
                        />
                        <Button
                            ref={buttonRef}
                            type={ButtonType.SECONDARY}
                            text={[].length > 1 ? "ردکردن" : "بارگذاری"}
                            className="w-[150px]"
                            onClick={handleSubmit}
                            autoFocus={true}
                        />
                    </div>
                    {props.files.length > 1 && (
                        <>
                            <hr />
                            <div onClick={() => setDoForAll(!doForAll)} className="flex items-center gap-2 mt-4 cursor-pointer">
                                <div
                                    className={`flex items-center justify-center shrink-0 border-[1.5px] border-secondary-500 w-[20px] h-[20px] rounded-[6px]
                                                 ${doForAll && "bg-primary-600 !border-primary-600"} 
                                                transition-all`}
                                >
                                    <img src={tick} alt="tick" className={`transition-all ${doForAll ? "opacity-100" : "opacity-0"}`} />
                                </div>
                                <span className="text-secondary-800 text-[14px]">برای {props.files.length - 1} فایل دیگر هم اعمال شود.</span>
                            </div>
                        </>
                    )}
                </div>
            )}
        </Dialog>
    );
}
